import { createAction } from 'redux-actions'
import i18next from 'i18next'

import { createRequestActions } from 'store/actionCreators'
import { GALLERIES_PATH, GALLERY_DELETE_IMAGE_PATH } from 'app/constants/api/galleries'
// @ts-ignore
import { GALLERY_IMAGE_DELETE_SUCCESS } from 'app/constants/toastrMessages'
// @ts-ignore
import { DELETE } from 'app/constants/requests'
import { IUploadImage } from 'store/entities/gallery/interfaces/actions.interface'
import { Map } from 'immutable'

export const fetchGalleryImages = createRequestActions('GALLERY_IMAGES/GET', organizationId => ({
  request: {
    url: GALLERIES_PATH(organizationId),
  },
}))

export const setPending = createAction('GALLERY_IMAGES/SET_PENDING', (pending: boolean) => ({
  pending,
}))

export const addImageToGallery = createAction(
  'GALLERY_IMAGES/ADD_IMAGE',
  (url: string, isConfirmRewriteImage: boolean) => ({
    url,
    isConfirmRewriteImage,
  })
)

export const uploadImage = createAction(
  'GALLERY_IMAGES/UPLOAD_REQUEST',
  ({ image, formName, formField, s3Entity, isConfirmRewriteImage }: IUploadImage) => ({
    image,
    formName,
    formField,
    s3Entity,
    isConfirmRewriteImage,
  })
)

export const resetLoaded = createAction('GALLERY_IMAGES/RESET_LOADED')

export const setImageToDelete = createAction('GALLERY_IMAGES/SET_IMAGE_TO_DELETE', (url: string) => ({ url }))

export const deleteImageFromGallery = createRequestActions('GALLERY_IMAGES/DELETE_IMAGE', url => ({
  request: {
    url: GALLERY_DELETE_IMAGE_PATH,
    method: DELETE,
    data: { url },
  },
  success: i18next.t(`admin:${GALLERY_IMAGE_DELETE_SUCCESS}`),
}))

export const setSearchBy = createAction('GALLERY_IMAGES/SET_SEARCH_BY', (by: string) => ({
  by,
}))

export const confirmRewriteImageTrigger = createAction(
  'GALLERY_IMAGES/CONFIRM_REWRITE_IMAGE_TRIGGER',
  (imageDomainWithId: string, fileName: string) => ({
    imageDomainWithId,
    fileName,
  })
)

export const setImageForReplace = createAction(
  'GALLERY_IMAGES/SET_IMAGE_FOR_REPLACE',
  (value: null | Map<string, any>) => ({
    value,
  })
)

export const setIsButtonDisable = createAction('GALLERY_IMAGES/SET_IS_BUTTON_DISABLE', (value: boolean) => ({ value }))

export const updateImageUsagePlaces = createAction(
  'GALLERY_IMAGES/UPDATE_IMAGE_USAGE_PLACES',
  (imagePath: string, usagePlaces: string) => ({
    imagePath,
    usagePlaces,
  })
)

export const increaseLazyLoaded = createAction('GALLERY_IMAGES/INCREASE_LAZY_LOADED')
